import { useCallback, useEffect, useState } from 'react'
import { useDispatchAsync } from '@src/utils/dispatch'
import { useSnack } from '@src/utils/navigatorContext'
import { EhrAppointmentQuery } from '../../graphql/ehrAppointment.generated'

interface AppointmentOptions {
  id?: string
  skip?: boolean
}

export const useAppointment = ({ id, skip }: AppointmentOptions) => {
  const dispatchAsync = useDispatchAsync()
  const [appointment, setAppointment] = useState<EhrAppointmentQuery['ehrAppointment']>()
  const [loading, setLoading] = useState(() => !skip)
  const [error, setError] = useState<string>()
  const showSnack = useSnack()

  const refetch = useCallback(async () => {
    setLoading(true)
    try {
      const appointment = await dispatchAsync<EhrAppointmentQuery['ehrAppointment']>({
        type: 'nutritionistHub/fetchEhrAppointment',
        payload: { id },
      })

      setAppointment(appointment)
      return appointment
    } catch (e: any) {
      setError(e.message)
      showSnack(e.message, null, 'error')
    } finally {
      setLoading(false)
    }
  }, [id, dispatchAsync, showSnack])

  useEffect(() => {
    if (skip || !id) {
      return
    }
    refetch()
  }, [skip, id, refetch])

  return { appointment, loading, error, refetch }
}
